import React from "react";
import { Box, Typography } from "@mui/material";

const MainDashboard = () => {
    return(
        <Box sx={{ 
            display: 'flex', 
            gap: '20px',
            margin: '3%',
            flexDirection: 'column'
         }}>
            <Typography variant='h5' sx={{ 
                width: 'auto',
                alignItems: 'center',
                textAlign: 'center',
                '@media (max-width: 600px)': {  // Ajustes para móviles
                    fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                    margin: '1% 5%',
                },
            }}>"El principal inconveniente de las personas y los países, es la pereza para encontrar las salidas y soluciones"</Typography>

<Typography variant='h5' sx={{ 
                width: 'auto',
                alignItems: 'center',
                textAlign: 'center',
                '@media (max-width: 600px)': {  // Ajustes para móviles
                    fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                    margin: '1% 5%',
                },
            }}>Albert Einstein</Typography>
        </Box>
    );
}

export default MainDashboard;